/**
 * 模板主图 / POD Canvas 服务端合成灰度。
 * 与后端 ipe.goods-template.server-worker-enabled 对齐；关则仍走浏览器长跑。
 */
export function isGoodsTemplateServerWorkerEnabled() {
  const raw = String(process.env.REACT_APP_GOODS_TEMPLATE_SERVER_WORKER || '').trim().toLowerCase();
  return raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
}
